import { useMyProfile } from "@app/utils/hooks";

export function useLegalSifterReview(): [boolean, string] {
  const [myProfile] = useMyProfile();
  const company = myProfile?.company;
  const lsrOrganizationId = company?.lsrOrganizationId;
  const isLsrActive = company?.lsrActive && lsrOrganizationId;
  return [isLsrActive, lsrOrganizationId];
}
